export default __webpack_public_path__ + "static/media/leetcode.f97b8901.webp";